import Alpine from 'alpinejs';
import "flatpickr/dist/themes/airbnb.css";
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import InfiniteScroll from 'infinite-scroll';
import {collapse} from "@alpinejs/collapse";
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {singleProductDatePicker} from "./components/singleProductDatePicker";
import {searchForm} from "./components/searchForm";
import {searchFormAnimations} from "./animations/searchForm";
import {loopProductGallery} from "./components/loopProductGallery";
import {guestInput} from "./components/guestInput";
import {inspectionGallery} from "./components/inspectionGallery";
import {singleProductGallery} from "./components/singleProductGallery";
import {accessForm} from "./components/accessForm";
import {singleProductAnimations} from "./animations/singleProduct";
import {shareButtons} from "./components/shareButtons";
import {contactForm} from "./components/contactForm";
import {serviceInput} from "./components/serviceInput";
import {aboutUsGallery} from "./components/aboutUsGallery";
import {archiveMap} from "./components/archiveMap";
import {wishlistButton} from "./components/wishlistButton";

window.InfiniteScroll = InfiniteScroll;
window.Alpine = Alpine;
Alpine.plugin(collapse);
window.Fancybox = Fancybox;

singleProductAnimations.bind();
searchFormAnimations.bind();
document.addEventListener('click', function (e) {
    const a = e.target.closest('a');
    if (!a) return;

    const href = a.getAttribute('href');
    window.unloadWithoutAnimation = href && href.startsWith('tel:');
});

function createSplide(elements,) {
    for (let i = 0; i < elements.length; i++) {
        new Splide(elements[i], {
            type: 'loop',
            lazyLoad: 'sequential',
            pagination: false,
            preloadPages: 0,
        }).mount();
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('glocalSlider')) {
        new Splide('#glocalSlider', {
            type: 'loop',
            lazyLoad: 'nearby',
            autoplay: true,
        }).mount();
    }

    if (document.getElementById('homeCategoriesSlider')) {
        new Splide('#homeCategoriesSlider', {
            type: 'loop',
            lazyLoad: 'nearby',
            perPage: 2,
            perMove: 1,
            mediaQuery: 'min',
            breakpoints: {
                '768': {
                    perPage: 4,
                }
            }
        }).mount();
    }
    const elements = document.getElementsByClassName('loop__product__gallery__splide');
    createSplide(elements);

    let container = document.getElementById('woocommerceProductsContainer');
    if (container && document.querySelector('.woocommerce-pagination .next')) {
        document.querySelector('.view-more-button').style.display = 'inline-block';
        let infScroll = new InfiniteScroll(container, {
            path: '.woocommerce-pagination .next',
            append: 'li.product',
            history: 'push',
            checkLastPage: true,
            loadOnScroll: false,
            hideNav: '.woocommerce-pagination',
            status: '.page-load-status',
            scrollThreshold: false,
            button: '.view-more-button',
        });

        infScroll.on('append', (body, path, items) => {
            createSplide(document.querySelectorAll('.loop__product__gallery__splide:not(.is-initialized)'));
        });

    }
});


Alpine.data('singleProductGallery', singleProductGallery);
Alpine.data('aboutUsGallery', aboutUsGallery);
Alpine.data('inspectionGallery', inspectionGallery)
Alpine.data('loopProductGallery', loopProductGallery);
Alpine.data('guestInput', guestInput)
Alpine.data('singleProductDatePicker', singleProductDatePicker);
Alpine.data('searchForm', searchForm);
Alpine.data('shareButtons', shareButtons);
Alpine.data('accessForm', accessForm);
Alpine.data('contactForm', contactForm);
Alpine.data('serviceInput', serviceInput);
Alpine.data('archiveMap', archiveMap);
Alpine.data('wishlist', wishlistButton)
Alpine.data('header', () => ({
    isHamburgerMenuOpen: false,
    isDesktop: false,
    showOnDesktop: false,
    isMobileSearchOpen: false,
    setMobileProperties() {
        this.isDesktop = window.innerWidth >= 960;
        this.isMobileSearchOpen = false;
        this.showOnDesktop = window.innerWidth >= 782;
    }
}));

Alpine.data('facets', (templateUri, broadArea) => ({
    templateUri,
    broadArea,
    getSrc() {
        return `${this.templateUri}/images/locations/${this.broadArea.toLowerCase()}.svg`
    }
}));
Alpine.start();